import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import DutiesAndTaxes from './';
import DutiesAndTaxesBanner from './banner';
import { useFulfillmentPlannerContext } from '../context';

import { shouldShowPrepayDutyAlert } from './helpers';
import { dutiesAndTaxesMessages } from './messages';
import style from './style.module.less';

const DutiesAndTaxesWithLabel = ({ fulfillmentPlanId }) => {
  const shouldShowPrepayDutyAlertBanner = useSelector((state) => shouldShowPrepayDutyAlert(state));
  const { shouldShowDutiesAndTaxes } = useFulfillmentPlannerContext();

  return (
    shouldShowDutiesAndTaxes && (
      <>
        <div className={style.label}>
          <FormattedMessage {...dutiesAndTaxesMessages.label} />
        </div>
        <div>
          <DutiesAndTaxes fulfillmentPlanId={fulfillmentPlanId} showBanner={!shouldShowPrepayDutyAlertBanner} />
        </div>
        <div />
        {shouldShowPrepayDutyAlertBanner && <DutiesAndTaxesBanner />}
      </>
    )
  );
};

DutiesAndTaxesWithLabel.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default DutiesAndTaxesWithLabel;
